import BaseChannel from '@/shared/classes/tv/BaseChannel'

export const getWidevineOttChannelsIds = (
    widevineOttChannelsList: BaseChannel[]
) => {
    const idsArray = widevineOttChannelsList.map(
        (channel: BaseChannel) => channel.id
    )
    return idsArray
}

export const getTvChannelsList = (channels: BaseChannel[]) => {
    if (!channels) return []
    const tvChannels = channels.filter(
        (channel: BaseChannel) => channel.service === 1
    )

    return tvChannels
}
